module.exports = __webpack_public_path__ + "static/covid-19-1_PLACEHOLDER-87cfca0b558cd8ec5b585cdb37766022.jpg";